import { makeImmutable } from "../core";
import { Availability } from "./Availability";
// Ported from the legacy PureScript `Restaumatic.Form.Validation.phoneNumber`:
// the number must match a loose phone shape and, after dropping an optional
// international prefix, contain a reasonable amount of digits.
const PHONE_REGEX = /^\+?[0-9 -]+$/;
/**
 * A phone number validated by format only (a loose regex plus a digit-count
 * check). Unlike {@link PhoneNumber}, it does not consult the backend, so it
 * suits contexts without a country/validation service — e.g. the marketing
 * consent-withdrawal form.
 */
export class RegexPhone {
    constructor(value) {
        this.value = value;
        makeImmutable(this);
    }
    static create(value) {
        return new RegexPhone(value.trim());
    }
    get isEmpty() {
        return this.value.length === 0;
    }
    toString() {
        return this.value;
    }
    get isValid() {
        if (!PHONE_REGEX.test(this.value)) {
            return false;
        }
        const digitCount = this.value
            .replace(/\+\d{1,3}/, "")
            .replace(/\D/g, "").length;
        return digitCount > 4 && digitCount < 16;
    }
    get availability() {
        return Availability.boolean({
            PhoneMissing: this.isEmpty,
            InvalidPhoneNumber: !this.isEmpty && !this.isValid,
        });
    }
}
RegexPhone.Empty = new RegexPhone("");
